//我的导航
//固定导航
const state = {
    nav_data: [
        {
            name: "baidu",
            title: "百度",
            href: "https://www.baidu.com/?tn=29021690_dg",
            icon: require("@/assets/images/zidingyiwangzhi/baidu.png")
        },
        {
            name: "taobao",
            title: "淘宝",
            href: "http://tb.yitsr.com/ytb16",
            icon: require("@/assets/images/zidingyiwangzhi/taobao.png")
        },
        {
            name: "tianmao",
            title: "天猫",
            href: "https://ad.yhzswl.com?cn=tm12",
            icon: require("@/assets/images/zidingyiwangzhi/tianmao.png")
        },
        {
            name: "jingdong",
            title: "京东",
            href: "http://jd.yitsr.com/yjd36",
            icon: require("@/assets/images/zidingyiwangzhi/jingdong.png")
        },
        {
            name: "1688",
            title: "1688",
            href: "https://1688.yhzswl.com?cn=168812",
            icon: require("@/assets/images/zidingyiwangzhi/1688.png")
        },
        {
            name: "qianwen",
            title: "千问",
            href: "https://www.qianwen.com?ch=webtongyi@other_houjiwebty_123dh_cpa&tag=brand",
            icon: require("@/assets/images/zidingyiwangzhi/qianwen.png")
        },
        {
            name: "doubao",
            title: "豆包",
            href: "https://doubao.com/",
            icon: require("@/assets/images/zidingyiwangzhi/doubao.png")
        },
        {
            name: "deepseek",
            title: "deepseek",
            href: "https://deepseek.com/",
            icon: require("@/assets/images/zidingyiwangzhi/deepseek.png")
        },
        {
            title: "携程",
            href: "https://ad.yhzswl.com?cn=xc1",
            icon: require("@/assets/images/zidingyiwangzhi/xiechen.png")
        },
        {
            name: "feizhu",
            title: "飞猪",
            href: "https://www.fliggy.com",
            icon: require("@/assets/images/zidingyiwangzhi/feizhu.png")
        },
        {
            name: "douyin",
            title: "抖音",
            href: "https://www.douyin.com/jingxuan?ug_source=doutui_hw_dy_ak56_fwkcln",
            icon: require("@/assets/images/zidingyiwangzhi/douyin.png")
        },
    ],
}
const mutations = {
}
const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
